/**
 * var-cell-colorize.js — Shared colorization for .var-cell elements.
 * Applies HSL gradient color (red←→green) based on data-value.
 * Only colorizes cells without data-locked="true" (respects blur).
 *
 * Usage:
 *   StocksReport.colorizeVarCells(document.getElementById('myTable'));
 *   StocksReport.colorizeVarCells(); // colorizes entire document
 */
(function() {
  'use strict';

  function getVarColor(value) {
    if (isNaN(value) || value === 0) return null;
    var t = Math.max(-30, Math.min(30, value)) / 30;
    var abs = Math.abs(t);
    var sat = Math.round(abs * 72 + 8);
    var light = Math.round(44 - abs * 8);
    var hue = t < 0 ? Math.round(25 * (1 - abs)) : Math.round(100 + abs * 40);
    return 'hsl(' + hue + ',' + sat + '%,' + light + '%)';
  }

  function colorize(scope) {
    var cells = (scope || document).querySelectorAll('.var-cell[data-value]:not([data-locked])');
    for (var i = 0; i < cells.length; i++) {
      var val = parseFloat(cells[i].getAttribute('data-value'));
      var color = getVarColor(val);
      if (color) cells[i].style.color = color;
    }
  }

  window.StocksReport = window.StocksReport || {};
  window.StocksReport.colorizeVarCells = colorize;
  window.StocksReport.getVarColor = getVarColor;

  /* Auto-colorize on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { colorize(); });
  } else {
    colorize();
  }

  /* Re-colorize on mutations (sort/filter/pagination) */
  if (typeof MutationObserver !== 'undefined') {
    var debounceTimer;
    var observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { colorize(); }, 50);
    });
    document.addEventListener('DOMContentLoaded', function() {
      var tables = document.querySelectorAll('.product-table__table, .ranking-table__body');
      tables.forEach(function(table) {
        observer.observe(table, { childList: true, subtree: true });
      });
    });
  }
})();
